import React from 'react';
import { Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';

const { Sider, Content } = Layout;

const AppLayout = ({ children }) => {
    const location = useLocation();
    const selectedKey = location.pathname;

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Sider>
                <Menu theme="dark" selectedKeys={[selectedKey]} mode="inline">
                    <Menu.Item key="/licenses">
                        <Link to="/licenses">许可证管理</Link>
                    </Menu.Item>
                    <Menu.Item key="/products">
                        <Link to="/products">产品管理</Link>
                    </Menu.Item>
                    <Menu.Item key="/activations">
                        <Link to="/activations">激活管理</Link>
                    </Menu.Item>
                    <Menu.Item key="/users">
                        <Link to="/users">用户管理</Link>
                    </Menu.Item>
                    <Menu.Item key="/auditlogs">
                        <Link to="/auditlogs">审计日志</Link>
                    </Menu.Item>
                </Menu>
            </Sider>
            <Layout>
                <Content style={{ margin: '16px' }}>{children}</Content>
            </Layout>
        </Layout>
    );
};

export default AppLayout;
